import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../../services/notification.service'; // NotificationService;
import { BasePackageGridCardDirective } from '../../../shared/components/base-package-grid-card.directive';
import { PackageGridCardFeaturesComponent } from '../../../shared/components/package-grid-card-features/package-grid-card-features.component';
import { ThemeBackgroundPipe } from '../../../shared/pipes/theme-background.pipe';

/**
 * A card component that renders a sales package item within a grid and emits selection events when the user selects the package. It extends BasePackageGridCardDirective to reuse shared package display logic and messaging.
 * The component exposes a package input (from the base directive) and an output event that notifies parent components of user selection. Key methods include onSelectPackage() which emits the selection event; the constructor injects NotificationService and forwards it to the base directive.
 * Lifecycle: this component relies on any lifecycle hooks implemented by BasePackageGridCardDirective (for example ngOnInit/ngOnDestroy) but does not introduce its own lifecycle hooks.
 * @component
 * @selector app-sales-package-grid-card
 * @example
 *   <app-sales-package-grid-card [package]="selectedPackage" (packageSelected)="onPackageSelected($event)"></app-sales-package-grid-card>
 * @input any package - The package data object to display in the card (inherited from BasePackageGridCardDirective).
 * @output EventEmitter<any> packageSelected - Emitted when the user selects the package; payload is the selected package object.
 */
@Component({
  selector: 'app-sales-package-grid-card',
  standalone: true,
  imports: [CommonModule, PackageGridCardFeaturesComponent, ThemeBackgroundPipe],
  providers: [NotificationService],
  templateUrl: './sales-package-grid-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./sales-package-grid-card.component.scss'],
})
export class SalesPackageGridCardComponent extends BasePackageGridCardDirective {
  @Output() packageSelected = new EventEmitter<any>();

  constructor(messageService: NotificationService) {
    super(messageService);
  }

  onSelectPackage(): void {
    this.packageSelected.emit(this.package);
  }

  trackByIndex(index: number): number {
    return index;
  }
  trackByValue(_: number, item: any): any {
    return item?.value ?? item;
  }
  trackById(_: number, item: any): any {
    return item?.id ?? item;
  }
  trackByString(_: number, s: any): any {
    return s;
  }
}
